import { firestore } from '../utilities/firebase'
import { errorOfType, errorTypes } from '../utilities/Errors'

const getUserProfileItemsWanted = async ({ uid }) => {
	try {
		const userProfileDocRef = firestore.collection('userProfiles').doc(uid)

		const itemsWantedQuerySnap = await userProfileDocRef.collection('itemsWanted')
			.orderBy('createdTimestamp', 'desc')
			.get()

		return itemsWantedQuerySnap.docs.map(d => d.data())
	} catch (error) {
		throw errorOfType(errorTypes.UNKNOWNERROR, uid, error)
	}
}

export default getUserProfileItemsWanted



// WEBPACK FOOTER //
// ./src/dataservices/getUserProfileItemsWanted.js